import React from 'react';

const Loader = () => (
	<div className="loader">
		<i className="icon-loading"></i>
		<span className="screen-reader-text">Loading...</span>
	</div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/index.js